angular.module('impactx.swimLane').directive('ixSwimLane', function() {
        var linkFn = function(scope, element, attrs) {
            scope.gridView = scope.showAsGrid;
            scope.showScrollerRight = false;
            scope.showScrollerLeft = false;

            if (attrs.hasOwnProperty("continueSearch")) {
                scope.continueSearch = true;
            }
        };
        return {
            scope: {
                header: '@header',
                morelabel: '@buttonlabel',
                morelink: '@morelink',
                showAsGrid: "=",
                template: '@template',
                elements: '=',
                trns: '=',
                numberOfRows: "=",
                moreFunction: "&",
                hasMoreFunction: "=",
                hideOptions: "=",
                largeCard: "=",
                hideHeader: "=?",
                filterPopup: "=?",
                filterFunction: "&?"
            },
            restrict: 'E',
            templateUrl: 'shared/swimlane/templates/swimlane.html',
            transclude: true,
            controller: "SwimLaneCtrl",
            link: linkFn
        }
    });

